// Must match PROTOCOL_NAME in electron/app/main.development.js
const PROTOCOL_NAME = 'ucaas';

/**
 * This function takes a path and redirects the user to the desktop app if it is installed.
 * The iframe is created and executes the deeplink instead of the main browser tab to make sure the user doesn't get stuck if the electron app isn't installed.
 * @param {String} path Must be a path and only include data after the domain. Eg: "/messages" or "/messages?foo=bar"
 */
export const executeAsDeeplink = (path) => {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = `${PROTOCOL_NAME}://${path}`;
    document.body.appendChild(iframe);

    // The timeout is needed due to the lifecycle events of iframes.
    // Without timeout the iframe is removed before the src can be populated and executed.
    setTimeout(() => {
        document.body.removeChild(iframe);
    }, 200);
};
